import "GIS/Map/Control/Base";
import "UI/Template";
import "UI/Element";

/** @namespace GIS.Map.Control */
NS("GIS.Map.Control");

/**
 * @class
 * @extends GIS.Map.Control.Base
 */
GIS.Map.Control.FollowMe = Class(GIS.Map.Control.Base, /** @lends GIS.Map.Control.FollowMe.prototype */ {
    /**
     * @type {$.<HTMLElement>}
     */
    $control: null,
    template: "GIS/Control/FollowMe",
    enabled: false,
    /** @inheritDoc */
    initialize() {
        this.ParentCall();
        this.render();
    },
    /**
     * @returns {GIS.Map.Control.FollowMe}
     */
    render() {
        this.$control = UI.Template.$render(this.template, {
            control: this
        });
        this.$control.appendTo(this.target || this.map.element);

        UI.Element.initEvent("click", "on-click", this.$control, this);

        return this;
    },
    /**
     * @returns {GIS.Map.Control.FollowMe}
     */
    destroy() {
        this.$control.remove() && (this.$control = null);

        return this.ParentCall();
    },
    /**
     * @param {HTMLElement} el
     * @param {$.Event} e
     * @protected
     */
    onFollowingClick(el) {
        $(el).toggleClass("on");

        this.enabled = !this.enabled;

        if (this.enabled) {
            this.map.getMap().startFollowing();
        } else {
            this.map.getMap().stopFollowing();
        }
    }
});
